import React, { FunctionComponent, useEffect, useState } from 'react';

import styles from './CollectSectionPopup.module.scss';
import { Grid } from '@material-ui/core';
import ManualGrabbingFormHeader from '../ManualGrabbingFormHeader';
import { _t } from 'app/utils/i18n';
import TextInput from 'app/components/Form/Inputs/TextInput';

interface Props {
  data: {
    register?: any;
    errors?: any;
    handleSubmit?: any;
    setError?: any;
    getValues?: any;
    watch?: any;
    setValue?: any;
    handleClick?: any;
    isLoading?: any;
    eyeValidate?: any;
    setIsOpenPopup?: any;
    url?: string;
    isOpenPopup?: boolean;
    categoryName?: string;
  };
}

const CollectSectionPopup: FunctionComponent<Props> = ({ data }) => {
  const {
    register,
    errors,
    handleSubmit,
    setError,
    getValues,
    watch,
    setValue,
    handleClick,
    isLoading,
    eyeValidate,
    setIsOpenPopup,
    url,
    isOpenPopup,
    categoryName,
  } = data;

  const [setValues, values] = useState<any>(getValues());

  useEffect(() => {
    setValue('source_edition_id', 0);
    setValue('sub_section_url', url);
    setValue('sub_section_selectors', '');
    setValue('section_name', categoryName);
    setIsOpenPopup(true);
  }, []);

  return (
    <Grid item md={12} className={styles.CollectSectionBox}>
      <div>
        <ManualGrabbingFormHeader
          title={_t('news:collect_sections')}
          handleClick={handleClick}
          disabled={isLoading}
          eyeValidate={eyeValidate}
          compId="news_add_source_categories_grabbing"
          hideIcon
          isOpenPopup={isOpenPopup}
        />
        <div className="mb-20">
          <TextInput
            label={_t('news:source_page') + ' *'}
            name="sub_section_url"
            register={register}
            error={errors?.sub_section_url?.message}
            value={getValues('sub_section_url')}
            dir="auto"
            disabled
          />
        </div>
        <div className="mb-30">
          <TextInput
            label={_t('news:Find_the_CSS_selector_element')}
            name="sub_section_selectors"
            error={errors?.sub_section_selectors?.message}
            value={getValues('sub_section_selectors')}
            dir="auto"
            onChange={(e: any) => {
              values((e: any) => ({
                ...e,
                sub_section_selectors: e,
              }));
              setValue('sub_section_selectors', e);
            }}
          />
        </div>
      </div>
    </Grid>
  );
};

export default CollectSectionPopup;
